<div class="card card-outline">
    <div class="card-header d-flex align-items-center">
        <h6 class="card-title mb-0 mr-3">
            Outros Custos e Recursos
        </h6>
        <button type="button" class="btn btn-sm btn-success" (click)="incluir()" *ngIf="!visualizar && permiteIncluir">
            <i class="fas fa-plus"></i>
        </button>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-12">
                <div class="mat-elevation-z1">
                    <table mat-table [dataSource]="osaExecucaoCustoRecursoDataSource">
                        <tr mat-header-row
                            *matHeaderRowDef="['nome', 'valorUnitario', 'quantidade', 'valorTotal', 'actions']"
                            class="bg-light"></tr>

                        <ng-container matColumnDef="nome">
                            <th mat-header-cell *matHeaderCellDef>Item </th>
                            <td mat-cell *matCellDef="let element"> {{ element.nome }}</td>
                        </ng-container>


                        <ng-container matColumnDef="valorUnitario">
                            <th mat-header-cell *matHeaderCellDef>Valor Unitário </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.valorUnitario | currency:'BRL':'symbol-narrow':'1.2-2' }}
                            </td>
                        </ng-container>


                        <ng-container matColumnDef="quantidade">
                            <th mat-header-cell *matHeaderCellDef>Quantidade </th>
                            <td mat-cell *matCellDef="let element"> {{ element.quantidade }}</td>
                        </ng-container>


                        <ng-container matColumnDef="valorTotal">
                            <th mat-header-cell *matHeaderCellDef>Custo Final </th>
                            <td mat-cell *matCellDef="let element">
                                {{ (element.valorUnitario * element.quantidade) | currency:'BRL':'symbol-narrow':'1.2-2' }}
                            </td>
                        </ng-container>

                        <ng-container cdkColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let element; let i = index" class="block">
                                <div class="btn-group">
                                    <button type="button" class="btn btn-primary btn-xs text-left" *ngIf="!visualizar && element.secaoId == 2"
                                        (click)="editar(element)">
                                        <i class="far fas fa-pen"></i></button>
                                    <button type="button" class="btn btn-danger btn-xs text-left" *ngIf="!visualizar && element.secaoId == 2"
                                        (click)="excluir(element.id)">
                                        <i class="far fa-trash-alt"></i></button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-row
                            *matRowDef="let row; columns: ['nome','valorUnitario', 'quantidade', 'valorTotal', 'actions'];">
                        </tr>
                    </table>
                    <h5 [hidden]="!osaExecucaoCustoRecursoSemDados" class="table-no-data">Nenhum custo e recurso
                    </h5>
                </div>
            </div>
            <div class="col-md-12">
                <div class="text-left mt-2 font-weight-bold">
                    Subtotal: {{ calcularSubtotal() | currency:'BRL':'symbol-narrow':'1.2-2' }}
                </div>
            </div>
        </div>
    </div>
</div>